import { render, staticRenderFns } from "./integrators.vue?vue&type=template&id=395be3ea&scoped=true"
import script from "./integrators.vue?vue&type=script&lang=js"
export * from "./integrators.vue?vue&type=script&lang=js"
import style0 from "./integrators.vue?vue&type=style&index=0&id=395be3ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395be3ea",
  null
  
)

export default component.exports